import { LOCALE_ID } from '@angular/core';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import { de, enGB, enUS, es, fr, nl } from 'date-fns/locale';

export const getSupportedDateLocale = (locale: string) => {
  switch (locale.substring(0, 2))
  {
    case 'en': 
      return locale === 'en_GB' ? enGB : enUS;
    case 'fr': 
      return fr;
    case 'de':
      return de;
    case 'nl':
      return nl;
    case 'es':
      return es;
    default:
      return enUS;
  }
}

const TM_DATE_FNS_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'P',
  },
  display: {
    dateInput: 'PP',
    monthYearLabel: 'LLL uuuu',
    dateA11yLabel: 'PP',
    monthYearA11yLabel: 'LLLL uuuu',
  },
};

export const TM_DATE_LOCALE_PROVIDERS = [
  {
    provide: MAT_DATE_LOCALE,
    useFactory: (localeId: string) => getSupportedDateLocale(localeId),
    deps: [LOCALE_ID],
  },
  { provide: MAT_DATE_FORMATS, useValue: TM_DATE_FNS_FORMATS },
]